import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export default function productSlideshow() {
  const lgQuery = window.matchMedia('(min-width: 1024px)');
  let handler;

  return {
    _swiper: null,

    init() {
      handler = (e) => this._toggle(e);
      this._toggle(lgQuery);
      lgQuery.addEventListener('change', handler);
      this.$el.addEventListener('alpine:destroy', () => {
        lgQuery.removeEventListener('change', handler);
        this._destroy();
      }, { once: true });
    },

    _toggle(e) {
      e.matches ? this._destroy() : this._create();
    },

    _create() {
      if (this._swiper) return;
      this.$el.classList.add('swiper');
      this._swiper = new Swiper(this.$el, {
        modules: [Pagination],
        slidesPerView: 1,
        pagination: {
          el: this.$refs.pagination,
          clickable: false,
        },
      });
    },

    _destroy() {
      if (!this._swiper) return;
      this._swiper.destroy(true, true);
      this.$el.classList.remove('swiper');
      this._swiper = null;
    },
  };
}
